import numeral from 'numeral';
import { twMerge } from 'tailwind-merge';
import toast from 'react-hot-toast';
import { type ClassValue, clsx } from 'clsx';
import type { AxiosError } from '@/types';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const ls = typeof window !== 'undefined' ? window.localStorage : null;

export const youtubeUrlRegex =
  /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w]+\?v=|embed\/|live\/|v\/)?)([\w]+)(\S+)?$/;

export const formatNumber = (number: number) => {
  return numeral(number).format('0a');
};

export const formatParticipants = (number: number) => {
  return numeral(number).format('0,0');
};

export const convertCountries = (input: any) => {
  if (!input) return [];

  const countries = input.map((country: any) => {
    const cities = country.city.map((city: string) => ({
      value: city,
      label: city,
    }));

    return {
      value: country.country,
      label: country.country,
      code: country.phone_number_prefix,
      cities,
    };
  });

  return countries;
};

export const getFilename = (url: string) => {
  const filename = url.split('/').pop();
  return filename;
};

export const swapSigns = (s: string = '') => {
  let result = '';

  for (const c of s) {
    if (c === '+') {
      result += '-';
    } else if (c === '-') {
      result += '+';
    } else {
      result += c;
    }
  }

  return result;
};

export const insertID = (array: any[]) => {
  return array.map((data: any, i: number) => {
    return { ...data, id: i + 1, errorMsg: '' };
  });
};

export const showErrorToast = (tr: any, error: AxiosError) => {
  const msg = error.response.data.message;
  toast.error(tr(msg));
};
